import { render, staticRenderFns } from "./ContractorsDeclarations.vue?vue&type=template&id=65b3ad6e&scoped=true&"
import script from "./ContractorsDeclarations.vue?vue&type=script&lang=js&"
export * from "./ContractorsDeclarations.vue?vue&type=script&lang=js&"
import style0 from "./ContractorsDeclarations.vue?vue&type=style&index=0&id=65b3ad6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3ad6e",
  null
  
)

export default component.exports